module.exports = __webpack_public_path__ + "media/images/e-kvitok/calendar-d3c2b5bb56f2da2710e283d7ff0830f2.svg";